export default __webpack_public_path__ + "static/media/Dapazin-10-eng.a23e205d.jpg";